import * as PIXI from "pixi.js"
import PixiScene from "../PixiScene";
import PixiCard from "./PixiCard";
//@ts-ignore
import { GlowFilter, OutlineFilter } from 'pixi-filters';
import MessageHelper from "../../../../../helpers/MessageHelper";
import PixiMessenger from "./PixiMessenger";

export default class PixiSelector {

    public static scene: PixiScene;
    private static tableList: Array<PixiCard> = [];
    private static  handList: Array<PixiCard> = [];

    public static all(): Array<PixiCard>
    {
        return [...PixiSelector.tableList, ...PixiSelector.handList];
    }

    /**
     * Добавить в выделение
     */
    public static add(item: PixiCard, shiftKey: boolean, rightClick: boolean, withBox = false, block = false): void
    {
        const inv:{[key: string]: string} = { table: 'hand', hand: 'table' };
        let card = item;
        if (card) {
            if (card.zone) {
                let zone = '' + card.zone;
                PixiSelector.clear(inv[zone]);
                if (!shiftKey && !rightClick) {
                    PixiSelector.clear(zone);
                }

                if (card.selected && withBox) {
                    // do nothing
                }
                else if (card.selected && !rightClick) {
                    card.selected = false;
                    if ('table' === zone) {
                        let index = PixiSelector.tableList.findIndex(it => it === card);
                        if (index >= 0) {
                            PixiSelector.tableList.splice(index, 1);
                        }
                        PixiMessenger.sendEnableCardMessage([card.pileId]);
                    }
                    if ('hand' === zone) {
                        let index = PixiSelector.handList.findIndex(it => it === card);
                        if (index >= 0) {
                            PixiSelector.handList.splice(index, 1);
                        }
                    }
                }
                else {
                    card.selected = true;
                    if ('table' === zone) {
                        if (!withBox) {
                            PixiMessenger.sendDisableCardMessage([card.pileId], block);
                        }
                        PixiSelector.tableList.push(card);
                    }
                    if ('hand' === zone) {
                        PixiSelector.handList.push(card);
                    }
                }
            }
            else {
                this.clearAll();
            }
        }
    }

    /**
     * Удалить пачки из выделения
     */
    public static removePiles(ids: Array<number>): void
    {
        let tableIds = PixiSelector.getTableIds();
        if (ids.some(id => tableIds.includes(id))) {
            let list = PixiSelector.tableList;
            let removeList = list.filter(card => ids.includes(card.pileId));
            removeList.forEach(card => card.deselectByOther());
            PixiSelector.tableList = list.filter(card => !ids.includes(card.pileId));
        }
    }

    /**
     * Очистка
     */
    private static clear(zone: string): void
    {
        if ('table' === zone && PixiSelector.tableList.length > 0) {
            PixiSelector.tableList.forEach((it: any) => {
                let card = (it as PixiCard);
                card.selected = false;
            });
            PixiSelector.tableList = [];
            PixiMessenger.sendEnableCardMessage();
        }
        if ('hand' === zone && PixiSelector.handList.length > 0) {
            PixiSelector.handList.forEach((it: any) => {
                let card = (it as PixiCard);
                card.selected = false;
            });
            PixiSelector.handList = [];
        }
    }

    /**
     * Полная очистка
     */
    public static clearAll(): void
    {
        PixiSelector.clear('table');
        PixiSelector.clear('hand');
    }

    /**
     * Выделенные пачки стола
     */
    public static getTableIds(): Array<number>
    {
        return PixiSelector.tableList.map((it: PixiCard) => it.pileId);
    }

    /**
     * Выделенные карты стола
     */
    public static getCardIds(): Array<number>
    {
        return PixiSelector.tableList.map((it: PixiCard) => it.cardId);
    }

    /**
     * Выделенные карты руки
     */
    public static getHandIds(): Array<number>
    {
        return PixiSelector.handList.map((it: PixiCard) => it.cardId);
    }

    /**
     * Выделенные карты / пачки
     */
    public static getSelected(zone: string): Array<PixiCard>
    {
        if ('table' === zone) {
            return PixiSelector.tableList;
        }
        if ('hand' === zone) {
            return PixiSelector.handList;
        }
        return [];
    }

    /**
     * Id выделенных карт / пачек
     */
    public static getSelectedIds(zone: string, fetchCards = false): Array<number>
    {
        if (fetchCards) {
            return PixiSelector.getCardIds();
        }
        if ('table' === zone) {
            return PixiSelector.getTableIds();
        }
        if ('hand' === zone) {
            return PixiSelector.getHandIds();
        }
        return [];
    }

    /**
     * Id карты / пачки
     */
    public static getId(card: PixiCard): number
    {
        if ('table' === card.zone) {
            return card.pileId;
        }
        if ('hand' === card.zone) {
            return card.cardId;
        }
        return 0;
    }

    /**
     * Зона выборки
     */
    public static get zone(): string
    {
        if (PixiSelector.tableList.length) {
            return 'table';
        }
        if (PixiSelector.handList.length) {
            return 'hand';
        }
        return '';
    }

    /**
     * Вернуть первую карту в выборке
     */
    public static get firstCard(): PixiCard | undefined
    {
        if (PixiSelector.tableList.length) {
            return PixiSelector.tableList[0];
        }
        if (PixiSelector.handList.length) {
            return PixiSelector.handList[0];
        }
        return undefined;
    }

    /**
     * Инфа для отладки
     */
    public static get info(): string
    {
        const zone = this.zone;
        return zone + ': ' + this.getSelectedIds(zone);
    }

}
